import { render, staticRenderFns } from "./allocateHouses.vue?vue&type=template&id=839b0c06&"
import script from "./allocateHouses.vue?vue&type=script&lang=js&"
export * from "./allocateHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('839b0c06')) {
      api.createRecord('839b0c06', component.options)
    } else {
      api.reload('839b0c06', component.options)
    }
    module.hot.accept("./allocateHouses.vue?vue&type=template&id=839b0c06&", function () {
      api.rerender('839b0c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/unitManager/allocateHouses.vue"
export default component.exports